// A properly typed `Object.entries`
export default function entries<T extends object>(
  obj: T
): [keyof T, T[keyof T]][] {
  return Object.entries(obj) as any;
}
